import * as catalogos from './catalogos/en';
export const locale = {
  lang: 'de',
  data: {
    'RESPONDE': catalogos.answer,
    'CONSULTATABLA': {
      'TITULO': 'Allgemeine Daten',
      'HEADER': 'Firmen',
      'BUSCAR': 'Firma suchen',
      'BUSCAR_PLACEH': 'Geben Sie den Namen der Firma ein, die Sie suchen möchten',
      'EMPRESA': 'Firma',
      'MESSAGE3':'<span> Wenn Sie sich sicher sind, dass Sie das Produkt logisch löschen wollen, geben Sie den rot markierten Text in das Textfeld ein: ',
      'MESSAGE4':'</span>',
      'CANCELAR': 'Abbrechen',
      'COMFIR': 'Bestätigen Sie',
      'PROC_DELE_PROD':'Produkt beseitigen',
      'SUCC_DELE_PROD':'Das Produkt wurde erfolgreich entfernt',
      'DELE_PRODU':'Produkt löschen',
      'TEX_VERS_RESULT_OPC1':'Standardversion',
      'TEX_VERS_RESULT_OPC2':'Benutzerdefinierte Version',
      'TEX_VERS_RESULT_LAB':'Benutzerdefinierte Version',
      'TEX_PLAC_RESULT_LAB':'Benutzerdefinierte Version eingeben',
      'TEX_MOD_RESULT_VERS':'Sie müssen den Typ der Ergebnisversion eingeben',
      'ACCION': 'Aktion',
      'CREAT_DATE_EMP':'Datum der Erstellung',
      'TYP_REGISTR_EMP':'Art der Registrierung',
      'AUTOR_EMP':'Autor',
      'SELECT_PLANTILLA': 'Bitte wählen Sie eine Vorlage aus',
      'SELECT_EMAIL_PLANTILLA': 'Bitte wählen Sie eine E-Mail-Vorlage',
      'DETALLE': 'Produkte',
      'MANAGER_TI': 'Leiter der IT',
      'STATUS': 'Umfrage-Status',
      'EMA_HISTO':'Mail History',
      'LABEL1': 'Unternehmensdaten',
      'DESCDETAIL': 'Reaktive Formulare von Angular fließen zwischen einem Nicht-UI-Datenmodell (typischerweise von einem Server abgerufen) und einem UI-orientierten Formularmodell, das die Zustände und Werte der HTML-Steuerelemente auf dem Bildschirm beibehält. Reaktive Formulare bieten die Einfachheit der Verwendung von reaktiven Mustern, Tests und Validierung',
      'DETAIL': 'Detail',
      'SECTOR': 'Sektor',
      'SUBSECTOR': 'Teilsektor',
      'RANKING': 'Rangfolge',
      'TIPO': 'Typ',
      '0': 'Weißes Icon-Design',
      '1': 'Gelbe Ikonengestaltung',
      '4': 'Icon Design Kreise',
      'Reactivos': 'Aussagen',
      'NPS': 'Übergreifende Aussage',
      'Demograficos': 'Demografisch',
      'Forall': 'Für alle',
      'Adicionales': 'Zusätzliche Aussagen',
      'Control': 'Kontrolle',
      'Abiertas': 'Offene Fragen',
      'URL': 'Link',

      'SELECCIONE_FECHA': 'Liste Jahr',
      'SELECT_CSSID': 'Jahr der Bewerbung',
      'SELECT_CSSIDR': 'Jahr der Rangliste',
      'TIPORANKING': 'Ranking-Typ ',
      'TIP_PRODU': 'Produkttyp',
      'TIP_PLAN_PRO': 'Name der Vorlage',
      'TIP_DIS_PRO': 'Entwurf',
      'SELECT_CSSID2': 'Auswahl eines Umfrageentwurfs',
      'SELECT_RESULTS': 'Selecciona un producto',
      'SURVEYTK_TITU': 'Umfrage-Token',
      'SURVEYTK_DESC': 'Geben Sie den Umfrage-Token für dieses Produkt ein',
      'TABLEAUVER_TITU': 'Ergebnisversion',
      'TABLEAUVER_DESC': 'Geben Sie die Ergebnissystemversion für dieses Produkt ein',
      'IDOPORTUNITY': 'Verkaufschancen-ID (Sales Force)',
      'NAMEOPORTUNITY': 'Name der Verkaufschance (Sales Force)',
      'IDTYPERESULT': 'Ergebnistypen',
      'NAM_USE_SWIFT':'Benutzername',
      'TO_USE_SWIFT':'Gesamtzahl der Mitwirkenden',
      'EMA_USE_SWIFT':'Benutzer-E-Mail',
      'PASS_USE_SWIFT':'Benutzerkennwort',
      'CAT_RES':{
        '1':'Vollständige Ergebnisse',
        '2':'Grundlegende Ergebnisse',
      },
      'PROYECTMANAGER': 'Projektmanager',
      'PROYECTMANAGER_MAIL': 'E-Mail des Projektmanagers',
      'CONFIGURE': 'Klicken Sie hier, um zu konfigurieren',
      'INFOR': 'Infos',
      'ADDPRODUCTS': 'Produkte hinzufügen',
      'ADD': 'Hinzufügen',
      'NAME_SURVEY':'Name der Umfrage:',
      'UPDATE_NAME_SURVEY':'Aktualisieren des Namens ',
      'LABELCONTRATADOS': 'Verwendete Produkte',
      'PRODUCTOS': catalogos.productos,
      'PRODUCTOSTURQUIA': catalogos.productosTurquia,
      'CATEGORIAS': catalogos.categorias,
      'GETLISTAEMP': 'Liste der registrierten Firmen laden',
      'EDITAR': 'Firmeninformationen bearbeiten',
      'LOGIN': 'Anmelden',
      'PAGINATOR_1': 'von',
      'PAGINATOR_2': 'Firmen',
      'TIMELINE': 'T.R. Zeitleiste',
      'PAQUETES': 'Pakete',
      'ELIMINAR': 'Firma löschen',
      'CORREOMODIF': 'Dieses Produkt hat Änderungen am E-Mail-Körper',
      'CORREOMODIFMODAL': 'Es gibt neue E-Mail-Änderungen, die in einem oder mehreren Produkten zur Überprüfung anstehen. Bitte überprüfen Sie diese',
      'CORREOMODAL_2': 'Neue E-Mail-Änderungen stehen derzeit zur Überprüfung an',
      'MODIFBTN': 'Produkteinstellungen',
      'INF_BTN': 'Produktinformation',
      'INF_PROD_SEL': 'Informationen zum Produkt',
      'VALIDMAIL_1': 'Änderungen validieren',
      'VALIDMAIL_2': 'Validierte E-Mail',
      'VALIDMAIL_3': 'Möchten Sie die Änderungen an der Nachricht validieren?',
      'VALIDMAIL_4': 'Die Änderungen an der E-Mail wurden korrekt validiert',
      'VALIDMAIL_5': 'Änderungen ablehnen',
      'VALIDMAIL_6': 'Möchten Sie die Änderungen an der Nachricht verwerfen?',
      'VALIDMAIL_7': 'Die Änderungen am E-Mail-Body wurden abgelehnt. Stattdessen wird die Standard-E-Mail-Vorlage verwendet',
      'VALIDMAIL_8': 'Abgelehnte E-Mail',
      'VALIDMAIL_9': 'Bearbeitung für die Firma freigeben',
      'VALIDMAIL_10': 'Möchten Sie die E-Mail-Bearbeitung für die Firma wieder freigeben?',
      'VALIDMAIL_11': 'Die Bearbeitung wurde für die Firma freigeschaltet',
      'VALIDMAIL_12': 'Mail bearbeiten',
      'VALIDMAIL_13': 'Jetzt können Sie die von der Firma gesendete E-Mail bearbeiten',
      'SINCORREOS': 'Es sind keine E-Mails zum Validieren vorhanden',
      'FILEMANODS': 'Dateimanager',
      'TEX-MENS-1': 'Die Firma',
      'TEX-MENS-2':'keine Benutzer',
      'FILEMAN_PRIV': 'Privates Laufwerk',
      'FILEMAN_PUB': 'Öffentliches Laufwerk',
      'USUARIO':'Benutzer',
      'AL':'bis',
      'SEN_EMAIL_REQ': 'Möchten Sie die E-Mail mit den technischen Anforderungen senden',
      'SEN_EMAIL_REQ_PROD': 'Schicken Sie unbedingt die E-Mail mit den technischen Anforderungen',
      'ETIQUE_SEN_EMAIL_REQ_PROD': 'Mailing Technische Anforderungen versenden',
      'EMAIL_REQ_PLACE':'Wählen Sie eine Sprache',
      'EMAIL_REQ_INTRO':'Wählen Sie eine Sprache zum Fortfahren',
      'WARN_SEN_EMAIL_REQ_PROD':'Um fortzufahren, müssen Sie eine Sprache auswählen',
      'TOOLTI_SEN_EMA': 'Mail versenden',
      'ESTA_EMA_TRUE': '*Mail senden',
      'ESTA_EMA_FALSE': '*Nicht gesendete Mail',
      'SEN_EMAIL_MODAL': 'Senden von E-Mail ......',
      'RTINFO': 'Informationen zu technischen Anforderungen',
      'TOOTI_RES_EMPR':'Ergebnisse empresing',
      'WARNI_SELCT_CHECK':'Um mit der Suche fortzufahren, müssen Sie mindestens ein Kästchen ankreuzen',
      'REQ':{
        'BTNSI':'Sim',
        'BTNNO':'Nein',
        'MENSAJE1':'Wollen Sie die technischen Anforderungen aktivieren?',
        'MENSAJE2':'Wollen Sie die technischen Anforderungen deaktivieren?',
      },
      'EDITORMAILODS': {
        'OPCION_1': 'E-Mail-Editor für dieses Produkt aktivieren',
        'OPCION_2': 'Automatische Validierung von Änderungen',
        'OPCION_3': 'Anforderungsdetails zum Umfrageprozess aktivieren',
        'OPCION_4': 'Umfragevalidierung für Fokusbereich aktivieren',
        'OPCION_5': 'Erlauben, die Anwendungszeit zu ändern',
        'OPCION_6': 'Erweiterungen zulassen',
        'OPCION_7': 'Erfolgschance auf Anforderungsdetails im Umfrageprozess',
        'OPCION_8': 'Anzahl der zuweisbaren Erinnerungen',
        'OPCION_9': 'Ausgabe des Abschlussdatums aktivieren',
        'OPCION_10': 'Wiedereröffnung von Schritten aktivieren',
        'OPCION_11_ENTREGABLES': 'Ergebnisse von Deliverables im Zählportal anzeigen',
        'OPCION_11_RANKING': 'Zertifizierungsergebnisse & Rangfolge im Zählportal anzeigen',
        'OPCION_12': 'Umfrageschutz mit Benutzer-PINs aktivieren',
        'OPCION_13':'Zufällige Validierungsfrage aktivieren',
        'OPCION_14':'Show Instrucctions Box in Survey App',
        'OPCION_15':'Show Support Box in Survey App',
        'OPCION_16':'Benutzernamen in der Umfrage-App anzeigen',
        'MODAL_OP11_ON': 'Die Funktion der Stufenwiederholung wurde für dieses Produkt aktiviert',
        'MODAL_OP12_OF': 'Die Schrittwiederholungsfunktion wurde für dieses Produkt deaktiviert',
        'MODAL_OP1_ON': 'Der E-Mail-Editor für dieses Produkt wurde aktiviert',
        'MODAL_OP1_OFF': 'Der E-Mail-Editor für dieses Produkt wurde deaktiviert',
        'MODAL_OP2_ON': 'Die automatische Änderungsprüfung wurde für dieses Produkt aktiviert',
        'MODAL_OP2_OFF': 'Die automatische Änderungsprüfung für dieses Produkt wurde deaktiviert',
        'MODAL_OP6_ON': 'Das Zulassen von Rollovers für dieses Produkt wurde aktivier',
        'MODAL_OP6_OFF': 'Das Zulassen von Rollovers für dieses Produkt wurde ausgeschaltet',
        'MODAL_OP7_ON': 'Die Anzahl der zuweisbaren Mahnungen für dieses Produkt wurde geändert',
        'MODAL_OP8_ON': 'Die Bearbeitung des Umfrageendtermins wurde für dieses Produkt aktiviert',
        'MODAL_OP8_OFF': 'Die Bearbeitung des Umfrageabschlussdatums für dieses Produkt wurde deaktiviert',
        'MODAL_OP11_ENTREGABLES_ON': 'Die Stichprobe der lieferbaren Ergebnisse wurde aktiviert',
        'MODAL_OP11_ENTREGABLES_OFF': 'Die Stichprobe der lieferbaren Ergebnisse wurde deaktiviert',
        'MODAL_OP11_RANKING_ON': 'Die Stichprobe der Zertifizierungs- und Ranking-Ergebnisse wurde aktiviert',
        'MODAL_OP11_RANKING_OFF': 'Stichprobe der Zertifizierungs- & Ranking-Ergebnisse wurde deaktiviert',
        'MODAL_PIN_ON': 'Pin ist aktiviert',
        'MODAL_PIN_OFF':'Pin ist deaktiviert',
        'MODAL_PRECONTROL_ON':'Zufällige Validierungsfrage wurde aktiviert',
        'MODAL_PRECONTROL_OFF':'Zufällige Überprüfungsfrage ist deaktiviert',
        'MODAL_OP14_ON': 'Hinweisbox in der Umfrageanwendung anzeigen ist aktiv',
        'MODAL_OP14_OFF': 'Hinweisbox in der Umfrageanwendung anzeigen ist deaktiviert',
        'MODAL_OP15_ON': 'Hinweisbox in der Umfrageanwendung anzeigen wurde aktiviert',
        'MODAL_OP15_OFF': 'Hinweisbox in der Umfrageanwendung anzeigen wurde deaktiviert',
        'MODAL_OP16_ON': 'Anzeige des Benutzernamens in der Umfrageanwendung ist aktiv',
        'MODAL_OP16_OFF': 'Anzeige des Benutzernamens in der Umfrageanwendung ist deaktiviert',
        'TITUOPTS': 'Optionen',
        'TITUCORRS': 'Noch zu validierende E-Mails',
        'SELLANG': 'Wählen Sie eine Sprache aus der Liste aus, um die E-Mail anzuzeigen',
        'SELLANG_L': 'Wählen Sie eine Sprache',
        'ASUNTO': 'Mail-Betreff',
        'ASUNTOPILOTO': 'Pilot-Mail-Betreff',
        'WAIT': 'Änderung speichern',
        'ULTD': 'Unbegrenzt',
        'CLOUD_LEGACY': 'Aktualisierte Version des Dateimanagers aktivieren',
        'CUSTOM_TEXT_CERT': 'Zertifikatstext für mehrere Standorte aktivieren',
        'CUSTOM_TEXT_CERT_EDIT': 'Bearbeiten Sie den Zertifikatstext',
        'TEXT_SECC_CONF_VOIC': 'Abschnitt zur Sprachkonfiguration anzeigen',
        'SAVED_CHANGES': 'Die Änderung wurde erfolgreich gespeichert',
        'CUSTOM_TEXT': {
          'TITULO': 'Listen Sie die Länder auf, in denen das Multi-Site-Zertifikat abgedeckt ist',
          'SUBTITULO': 'Schreiben Sie den neuen Text',
          'SUBTITULO2': 'Achtung, wenn Sie den Text ändern und auf die Schaltfläche OK klicken, wird der aktuelle Text überschrieben',
          'HINT': 'Zertifikatstext',
          'OK': 'Annehmen',
          'CANCEL': 'Abbrechen',
          'SAVED_CHANGES': 'Der Text wurde korrekt gespeichert',
          'CURRENT_T1': 'Aktueller Multi-Site-Text',
          'CURRENT_T2': 'Der aktuelle Multi-Site-Text ist sehr lang. Um ihn anzuzeigen, klicken Sie auf die Schaltfläche Bearbeiten',
        }
      },
      'ASOCIARCERTIFICAR':{
        'CHECK':'Kulturaudit mit einem Zertifikat verknüpfen',
        'INPUT':'Zuzuordnendes Zertifikat',
        'INPUT_2':'Zuzuordnendes Produkt',
        'CERTIFICAR':'Zertifizieren',
        'MEDIR':'Maßnahme',
      },
      'LOG_SISTEMA':{
        'TITULO':'System Log',
        'BUSCADOR':'Suchergebnisse',
        'PLACEHOLDER':'Suche',
        'ACTUALIZAR':'Protokoll aktualisieren',
        'PAGINA':'Seite',
        'CARGA':'Daten laden...',
        'TABLA':{
          'IMAGEN':'Bild',
          'IP':'Client IP',
          'USER':'Benutzer',
          'COMPANY':'Firma',
          'PLATFORM':'Plattform',
          'STATUS':'Status',
          'RESULT':'Ergebnis',
          'DATE':'Datum',
        },
      },
      'LOG_SENDGRIND':{
        'TITULO':'SendGrid\'s Log',
        'OPCION':'Wählen Sie eine Option:',
        'TOOLTIP':'Suchstatus',
        'TABLA':{
          'USUARIO':'Benutzer',
          'EMAIL':'E-Mail',
          'ASUNTO':'Betreff',
          'ESTATUS':'Status'
        },
        'DIALOG_SENDGRIND':{
          'TITTULO':'Mailing Information',
          'TO':'An',
          'FROM':'From',
          'SUBJECT':'Betreff',
          'HISTORIAL':'Mail-Verlauf',
          'ESTATUS':'Status',
          'ABIERTO':'Zeiten offen:',
          'ULTIMO_EVENTO':'Letztes Ereignis:',
          'SIN_CORREOS':'Ihr E-Mail-Verlauf ist nicht verfügbar!',
          'BOTON':'Schließen',
          'NOTE':'HINWEIS: Die in der Liste angezeigte Datums-/Zeitangabe ist auf die Ortszeit in ',
        },
      },
      'CONFIR_CAMBIOS_SECCION':'Derzeit ist die Umfrage bereits erstellt,\n\n sind Sie sicher, dass Sie die Änderungen vornehmen möchten? Wenn Sie bestätigen?, \n\nerzeugen Sie die Umfrage erneut',
      'MODAL_CAMBIOS_SECCION':'Abschnitte aktualisieren',
      'TIT_MOD_AGRE_ENCU':'Neuer Umfrageprozess',
      'TEX_NAM_SUR':'Umfragename:',
      'TEX_PLA_SUR':'Vorlagenauswahl',
      'BTN_AGRE_SUR':'Hinzufügen',
      'PLA_TEX_NAM_SUR':'Umfragename:',
      'PLA_TEX_PLA_SUR':'Vorlagenauswahl',
      'WARNI_NOT_SURV_NOM35':'Die Umfrage wird derzeit nicht erstellt',
      'MODAL_CREAT_INFRA':'Infrastruktur wird gerade erstellt, bitte warten',
      'MODAL_ERROR_INFRA':'Bei der Erstellung der Infrastruktur ist ein Fehler aufgetreten',
    },
    'GESTORSTATUS': {
      'BOTACCESO': 'Informationen über Produkte',
      'TITULO': 'Erworbene Produkte',
      'PRODUCTOS':{
        'CERTIFICAR': 'Zertifizieren',
        'MEDIR': 'Messung',
        'PULSE': 'Pulskontrolle',
        'FOCUS': 'Fokusbereich',
        'NUMPROD': 'Anzahl der Produkte: ',
        'BOTACCESO': 'Produkte sehen',
        'NOPRODUCTOS': 'Sie haben keine erworbenen Produkte'
      },
      'PRODSINFO': {
        'ADQUIRIDOS': 'Erworbene Produkte',
        'SELECCIONE': 'Wählen Sie ein Produkt aus der Liste, um dessen Informationen anzuzeigen'
      },
      'STATUS': {
        'LISTA': 'Schrittliste',
        'AKTUELL': 'Schrittstatus',
        'INFO': 'Diese Liste zeigt den aktuellen Status für jeden Schritt des Zertifizierungsprozesses an.\n\nSie können den Status von "Abgeschlossen" auf "Nicht abgeschlossen" ändern, indem Sie auf einen Schritt-Schieberegler klicken.\n\nHinweis: Einige Schrittstatus können nur unter bestimmten Bedingungen geändert werden.',
        'NO': 'Nicht abgeschlossen',
        'SI': 'Schritt abgeschlossen',
        'TOOLTIP': {
          'HELP': 'Klicken Sie hier, um mehr zu erfahren',
          'SLIDER': 'Klicken Sie hier, um den Status für diesen Schritt zu ändern'
        }
      }
    },

    'ALERTS': {
      'OK': 'OK',
      'ODSINSERTOK': 'Die Firma wurde korrekt registriert',
      'ODSFAILINSERT': 'Der Registrierungsvorgang ist fehlgeschlagen, bitte versuchen Sie es erneut',
      'COLPLETEFORM1': 'Bitte schließen Sie Schritt 1 ab',
      'COLPLETEFORM2': 'Bitte Schritt 2 abschließen',
      'COLPLETEFORM3': 'Bitte Schritt 3 abschließen',
      'COLPLETEFORM4': 'Bitte Schritt 4 ausfüllen',
      'COLPLETEFORM5': 'Bitte Schritt 5 abschließen',
      'ODSEXIST': 'Die Firma ist bereits im System registriert. Die Info wurde nicht gespeichert',
      'MAIL':'¿Sie möchten die Mail erneut an die verschiedenen Zuständigen senden?',
      'RSPSI':'Sí',
      'RSPNO':'Nein',
      'LABEL01':'Sie haben bereits ein NOM 035 Produkt',
      'FIELD':'Erforderlicher Link',
      'PASSWORD': {
        'LONGITUD': 'Das Passwort muss mindestens acht Zeichen lang sein',
        'MINUSCULAS': 'Das Passwort muss mindestens einen Kleinbuchstaben enthalten',
        'MAYUSCULAS': 'Das Passwort muss mindestens einen Großbuchstaben enthalten',
        'NUMEROS': 'Das Passwort muss mindestens ein numerisches Zeichen haben',
        'ESPCHARS': 'Das Passwort muss mindestens ein Sonderzeichen enthalten, nicht alphanumerisch',
        'VALIDACION': 'Beim Überprüfen des Kennworts ist ein Problem aufgetreten. Geben Sie es erneut ein und versuchen Sie, den Benutzer erneut zu erstellen'
      }
    },
    'TI_MANAGER': {
      'TITULO': 'IT-Manager',
      'BESCHREIBUNG': 'Geben Sie die Daten des IT-Managers ein, um die notwendigen Informationen und Einstellungen zu übermitteln, die vor der Anwendung der Umfrage ausgeführt werden müssen',
      'DATOS': 'Daten',
      'NOMBRE': 'Name',
      'APELLIDOS': 'Nachname',
      'EMAIL': 'E-Mail',
      'TELEFONO': 'Telefon',
      'EXTENSION': 'Durchwahl',
      'CELULAR': 'Mobiltelefon'
    },
    'PERFILES': {
      'CABECERA':{
        'TITULO': 'PROFILE CREATOR',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'BOTONES':{
        'BOT1':{
          'TITULO': 'Firmenprofil',
          'BOTON': 'Erstellen'
        },
        'BOT2':{
          'TITULO': 'Benutzerprofil',
          'BOTON': 'Admin'
        },
        'BACK': 'Zurück',
        'NEXT': 'Weiter',
        'RESET': 'Zurücksetzen',
        'EDIT': 'Speichern'
      },
      'EMPRESA':{
        'WAIT': 'Warten...',
        'TITUHEAD': 'Firmenprofil',
        'CLOUD': 'Privater Ordner',
        'INFO': 'Profil für eine Firma erstellen',
        'INFOMOD': 'Sie können die Profildaten dieser Firma ändern <b>(Änderungen werden automatisch gespeichert)</b>',
        'PDF':{
          'BOTONDESCARGA':'Informationen im PDF-Format herunterladen',
          'FECHA':'Datum: ',
          'HORA':'Zeit: ',
          'MODAL':'Datei zum Download generieren...',
        },

        'ACTUALIZARCA':{
          'ACTUALIZARCA':'Update Kultur-Audit',
          'ACTUALIZARCA_BRI':'Update Kulturbrief',
          'ACTUALIZARCA_ACTIAN':'Aktionsplan aktualisieren',
          'CERRAR':'Schließen',
          'SUCCESS':'Kultur-Audit erfolgreich aktualisiert',
          'SUCCESS_ACTION':'Aktionsplan erfolgreich aktualisiert',
          'ERROR':'Fehler, Ihr Culture Audit hat kein zertifiziertes Produkt',
          'ERROR_ACTION':'Error, your Plan action does not have a certified product',
        },

        'ACTUALIZAR_BD':{
          'TITULO':'Anweisungen',
          'INSTRUCCIONES':{
            'INSTRUCCION_1':'Laden Sie die Datenbank der Mitarbeiter herunter, die ich in der Plattform hinterlege',
            'INSTRUCCION_2':'Laden Sie die von der Plattform bereitgestellte Vorlage herunter und kopieren Sie die Daten aus Ihrer Mitarbeiterdatenbank in diese Vorlage.',
            'INSTRUCCION_3':'Nehmen Sie die notwendigen Änderungen an Ihrer Kollaborator-Datenbank vor.',
            'INSTRUCCION_4':'Sobald die Änderungen an Ihrer Mitarbeiterdatenbank abgeschlossen sind, löschen Sie Ihre bisherige Mitarbeiterdatenbank.',
            'INSTRUCCION_5':'Klicken Sie auf die Schaltfläche zum Hochladen Ihrer aktualisierten Mitarbeiterdatenbank und klicken Sie auf "Akzeptieren".'
          },
        },

        'SECCIONES':{
          'SEC1': {
            'TITULO': 'Firmeninfo',
            'TITULOPDF': 'Firmeninfo',
            'NOMEMP': 'Firmenname',
            'NOM': 'Name',
            'SECTORREQUIRED': 'Sectorrequired\n\nBranche erforderlich',
            'SUBSECTORREQUIRED': 'Untersektor ist erforderlich',
            'ANIOFU': 'Gründungsjahr',
            'SALESFORCE': 'Salesforce ID',
            'CODE': 'Firmen-ID',
            'SALES_REQUIRED': 'Salesforce ID ist erforderlich',
            'CODE_REQUIRED': 'Die Unternehmens-ID ist erforderlich',
            'INSTITUTO': 'Institut',
            'INSTITUTO_REQUIRED': 'Institut ist erforderlich',
            'COMPANY': 'Unternehmen',
            'COMPANY_REQUIRED': 'Der Name des Unternehmens ist erforderlich',
            'CAMPO_INVALID': 'Das Feld lässt die folgenden Zeichen nicht zu /*?"<>:\'',
            'COMPANY_ACOR': 'Firmenkurzname ',
            'MOD_INGRE_ACORT': 'Um fortzufahren, geben Sie den Kurznamen des Unternehmens ein',
            'ACORT_REQUIRED': 'Firmenkurzname ist erforderlich',
            'SEDE': 'Gastland',
            'SEDE_REQUIRED': 'Es ist notwendig, das Gastland auszuwählen, um fortzufahren',
            'PUBLICATION': 'Listenname',
            'PUBLICATION_REQUIRED': 'Der Name der Publikation ist erforderlich',
            'FUNDATION': 'Gründungsjahr',
            'FUNDATION_REQUIRED': 'Das Gründungsjahr der Firma ist erforderlich',
            'EMP_TC_REQUIRED': 'Die Anzahl der Vollzeitmitarbeiter ist erforderlich',
            'EMP_TP_REQUIRED': 'Die Anzahl der Teilzeitbeschäftigten ist erforderlich',
            'TOTCOL_REQUIRED': 'Bitte geben Sie die Gesamtzahl der Mitarbeiter ein',
            'RANKING': 'Rangfolge',
            'RANKING_REQUIRED': 'Bitte wählen Sie ein Ranking',
            'TIPO': 'Bereich der Mitarbeiter',
            'TIPO_REQUIRED': 'Bitte wählen Sie einen Bereich von Mitarbeitern',
            'MULTINACIONAL': 'Multinational',
            'MULTINACIONAL_REQUIRED': 'Bitte wählen Sie aus, wenn Sie multinational sind',
            'ANIORANK_REQUIRED': 'Geben Sie das Listenjahr ein',
            'REGION': 'Region',
            'REGION_REQUIRED': 'Geben Sie Ihre Region ein',
            'PAIS': 'Land',
            'ESTADO': 'Staat, Stadt oder Provinz',
            'NAM_RANKIN':'Ranglistenname',
          'TYP_RANKIN':'Typ-Ranking',

            'OPTSI': 'Ja',
            'OPTNO': 'Nein',

            'EMP_TC': 'Full time-employees',
            'EMP_TP': 'Teilzeitbeschäftigte',
            'TOTCOL': 'Anzahl der Mitarbeiter',
            'ANIORANK': 'Listenjahr',
            'ETIQ_CATALOGOS':{
              'SECTOR': 'Wählen Sie einen Sektor',
              'SUBSECTOR': 'Wählen Sie einen Teilsektor',
              'MULTIN': 'Multinational',
              'TIPO': 'Typ (Rang oder Sektor)',
              'REGION': 'Wählen Sie eine Region'
            },
            'CATALOGOS':{
              'INSTITUTOS': catalogos.institutos,
              'SECTORES': catalogos.sectores,
              'RANKING': catalogos.ranking,
              'REGIONES': catalogos.regiones,
            }
          },
          'SEC2': {
            'TITULO': 'Kultureller GO-Kontakt',
            'NOM': 'Vorname',
            'APE': 'Nachname',
            'EMAIL': 'E-Mail',
            'TEL': 'Telefonnummer',
            'EXT': 'Durchwahl',
            'CEL': 'Mobiltelefon',

            'NOM_REQUIRED': 'Geben Sie einen Namen ein',
            'APE_REQUIRED': 'Geben Sie Ihren Nachnamen ein',
            'EMAIL_REQUIRED': 'Geben Sie Ihre E-Mail ein',
            'TEL_REQUIRED': 'Geben Sie Ihr Telefon ein',
            'EXT_REQUIRED': 'Geben Sie eine Durchwahl ein',
            'CEL_REQUIRED': 'Geben Sie Ihr Mobiltelefon ein'

          },
          'SEC3': {
            'TITULO': 'HR Director',
            'NOM': 'Vollständiger Name',
            'EMAIL': 'E-Mail',
            'TEL': 'Telefonnummer',
            'EXT': 'Durchwahl',
            'CEL': 'Mobiltelefon',

            'NOM_REQUIRED': 'Geben Sie einen Namen ein',
            'EMAIL_REQUIRED': 'Geben Sie Ihre E-Mail ein',
            'TEL_REQUIRED': 'Geben Sie Ihr Telefon ein',
            'EXT_REQUIRED': 'Geben Sie eine Durchwahl ein',
            'CEL_REQUIRED': 'Geben Sie Ihr Mobiltelefon ein'

          },
          'SEC4': {
            'TITULO': 'IT-Kontakt',
            'NOM': 'Vollständiger Name',
            'EMAIL': 'E-Mail',
            'TEL': 'Telefonnummer',
            'EXT': 'Durchwahl',
            'CEL': 'Mobiltelefon',
            'REGISTER': 'Registrieren',

            'NOM_REQUIRED': 'Geben Sie einen Namen ein',
            'EMAIL_REQUIRED': 'Geben Sie Ihre E-Mail ein',
            'TEL_REQUIRED': 'Geben Sie Ihr Telefon ein',
            'EXT_REQUIRED': 'Geben Sie eine Durchwahl ein',
            'CEL_REQUIRED': 'Geben Sie Ihr Mobiltelefon ein'

          },
          'SEC5': {
            'TITULO': 'Deliverables',
            'ENTRE': 'Deliverable',
            'TIPO': 'Typ'
          }
        },
        'MENSAJES':{
          'CARGABD': 'BD hochladen',
          'STATUS': 'STATUS',
          'CORRECTO': 'Das Firmenprofil wurde erfolgreich erstellt',
          'ERROR': 'Beim Erstellen des Firmenprofils ist ein Fehler aufgetreten',
        }
      },
      'USUARIO':{
        'TITULO_LOGIN':'Wählen Sie den Benutzer, mit dem Sie sich anmelden möchten',
        'MJS_COMPLETE_INFO': 'Bitte geben Sie die Informationen ein.',
        'MSJ_INVALIDEMAIL': 'Bitte geben Sie eine gültige E-Mail ein.',
        'MSJ_SELECTCOMPANY': 'Bitte wählen Sie eine Firma aus',
        'REGISTER_SUCCESS': 'Benutzer erfolgreich registriert',
        'REGISTER_SUCCESS_SWIFT': 'Benutzer erfolgreich registriert, es wurde eine E-Mail zur Aktivierung an Ihren Benutzer gesendet',
        'REGISTER_ERROR': 'Fehler, der Benutzer konnte sich nicht registrieren, bitte versuchen Sie es erneut',
        'PRODUCT_REGISTEROK': 'Produkt korrekt registriert',
        'PRODUCT_REGISTERPREVIOUS': 'Produkt wurde bereits registriert.',
        'PRODUCT_REGISTERFAIL': 'Fehler beim Registrieren des Produkts, bitte versuchen Sie es erneut',
        'CERTIFICAR_EXISTENTE': 'Das zertifizierte Produkt existiert bereits',
        'CERTIFICAR_NO_TERMINADO': 'Um das folgende Produkt hinzuzufügen, müssen Sie mit dem Zertifikat für das Jahr abschließen',
        'CERTIFICAR_NO_EXISTENTE': 'Um das Pulsecheck-Produkt hinzuzufügen, müssen Sie das Zertifikat für das Jahr erwerben',
        'PULSOS-COMPLETOS':'Derzeit haben Sie die erlaubten Pulse',
        'MSJ_SELECTYEAR': 'Bitte wählen Sie ein Jahr aus',
        'MSJ_SELECTYEARRESULTS': 'Es necesario tener un producto tipo',
        'MSJ_34': 'Es necesario seleccionar un producto tipo Certificar',
        'MSJ_35': 'Es necesario seleccionar un producto tipo Medir',
        'MSJ_36': 'Es necesario seleccionar un producto tipo Forall',
        'MSJ_SELECTPRODUCT': 'Bitte wählen Sie ein Produkt aus',
        'MSJ_SELECTTEMPLETE': 'Bitte wählen Sie eine Vorlage',
        'MSJ_SELECTEMAILTEMPLETE': 'Bitte wählen Sie eine E-Mail-Vorlage',
        'SIN_USUARIO': 'Sie müssen einen Benutzer für diese Firma registrieren, um dieses Produkt hinzufügen zu können',
        //'SIN_SURVEYTOKEN': 'Sie müssen das Umfrage-Token eingeben, um es diesem Produkt zuordnen zu können',
        'MISMOANIOCERTIFICAR': 'Das Produkt kann nicht hinzugefügt werden, Sie haben bereits ein Certify-Produkt aus demselben Jahr, wählen Sie ein anderes Jahr und versuchen Sie es erneut',
        'SIN_SURVEYTOKEN': 'Für das Jahr dieses Produkts gibt es noch keine Umfrage',
        'SIN_CERTIFICAR_ASOCIA': 'Sie müssen noch ein zertifiziertes Produkt zuordnen',
        'SIN_TABLEAUVER': 'Sie müssen die Ergebnisversion eingeben, die diesem Produkt zugeordnet werden soll, um es zuzuordnen',
        'SINRANKING': 'Sie müssen das Ranking-Jahr für dieses Produkt auswählen, bevor Sie fortfahren',
        'SINTIPORANK': 'Sie müssen die Art des Rankings für dieses Produkt auswählen, bevor Sie fortfahren',
        'SINIDOPORTUNITY': 'Sie müssen die Opportunity-ID für dieses Produkt eingeben, bevor Sie fortfahren können',
        'SINNAMEOPORTUNITY': 'Sie müssen den Opportunity-Namen für dieses Produkt eingeben, bevor Sie fortfahren',
        'SINIDTYPERESULT': 'Sie müssen den Ergebnistyp für dieses Produkt eingeben, bevor Sie fortfahren',
        'SINPROYECTMANAGER': 'Sie müssen den Namen des Projektmanagers für dieses Produkt eingeben, bevor Sie fortfahren',
        'SINCORREOPM': 'Sie müssen die E-Mail des Projektmanagers für dieses Produkt eingeben, bevor Sie fortfahren',
        'EMAILNOVALIDO': 'Die eingegebene E-Mail des Projektmanagers hat kein gültiges Format, bitte überprüfen Sie diese und geben Sie sie erneut korrekt ein',
        'GUARDANDOPRODUCTO': 'Das ausgewählte Produkt wird dem Unternehmen hinzugefügt, bitte warten Sie einen Moment',
        'TOKENMODAL_1': 'Dies ist das Umfrage-Token des neu hinzugefügten Produkts',
        'TOKENMODAL_2': 'Was willst du als nächstes tun?',
        'TOKEN_SI': 'Kopieren Sie das Token',
        'TOKEN_NO': 'Weitermachen',
        'TOKEN_COPIADO': 'Umfrage-Token wurde erfolgreich in die Zwischenablage kopiert',
        'ERROR1':'Sie haben bereits ein registriertes Produkt in diesem Jahr',
        'TITUHEAD': 'Benutzerprofil',
        'TITUCREARHEAD': 'Benutzer anlegen',
        'TITUBUSCARHEAD': 'Benutzer suchen',
        'TITUBUSCAREMPRESA': 'Firma suchen',
        'TITUUSERGPTWHEAD': 'Admin Users',
        'INFO': 'Profil für einen Benutzer',
        'USUARIO': 'E-Mail',
        'USE_NAM': 'Benutzer-Name',
        'USUARIOREQUIRED': 'Email ist erforderlich',
        'USUARIONAMEREQUIRED': 'Benutzername ist erforderlich',
        'CONTRAREQUIRED': 'Das Passwort ist erforderlich',
        'LEVELREQUIRED': 'Wählen Sie ein Level',
        'CONTRA': 'Passwort',
        'FIRMA': 'Firma',
        'NIVEL': 'Berechtigungsstufe',
        'NIVELES': catalogos.niveles,
        'GUARDA':'Speichern',
        'TH-NOMEMPRE':'Firmenname',
        'TH-USUARIO':'Benutzer',
        'TH-TUSUARIO':'Benutzertyp',
        'TH-ACCIONES':'Aktionen',
        'TH-LOGIN':'Anmeldung',
        'TH-INSTITUTO':'Institut',
        'ACC-DELET':'Benutzer löschen',
        'ACC-EDIT':'Benutzer bearbeiten',
        'UPDATE-USER':'Richtig aktualisiert',
        'EXIST-USER':'Bestehender Benutzer',
        'ALERT-EDIT':'Sind Sie sicher, dass Sie den Benutzer ändern wollen?',
        'USUARIO-T':'Usuarios',
        'CONFIRM_ELIMINAR_USU':'Sind Sie sicher, dass Sie den Benutzer löschen wollen?',
        'INGR_ELIMINAR_USU':'<span>Geben Sie den rot markierten Benutzer in das Textfeld ',
        'INGR_ELIMINAR_USU.2':'</span>',
        'ERROR_ELIMINAR_USU':'Der eingegebene Benutzer stimmt nicht überein',
        'OK_ELIMINAR_USU':'Benutzer wurde korrekt gelöscht',
        'PASSWORDSAFE': 'Das Passwort sollte mindestens 8 Zeichen lang sein: mindestens 1 Ziffer, mindestens 1 Kleinbuchstabe, mindestens 1 Großbuchstabe und mindestens 1 nicht alphanumerisches Zeichen',
        'PRODUCT_EXIST':'Das Produkt mit dem ausgewählten Datum existiert bereits',
        'WAR_ADD_NA_US':'Bitte geben Sie den Benutzernamen ein',
        'WAR_ADD_TOT_US':'Bitte geben Sie die Gesamtzahl der Mitwirkenden ein',
        'WAR_ADD_EMA_US':'Bitte geben Sie die E-Mail-Adresse des Benutzers ein',
        'WAR_ADD_PASS_US':'Bitte geben Sie das Benutzerkennwort ein',
        'WAR_INCO_EMA_US':'Die eingegebene E-Mail ist falsch',
        'WAR_INCO_PASS_US':'Das Kennwort entspricht nicht dem zulässigen Format',
        'MOD_SAV_US':'Benutzer speichern',
        'MENSAJES':{
          'CARGABD': 'BD hochladen',
          'STATUS': 'STATUS',
          'CORRECTO': 'Benutzer erfolgreich registriert',
          'ERROR': 'Beim Erstellen des Benutzerprofils ist ein Fehler aufgetreten'
        }
      }
    },
    'CONSULTARENCUESTA':{
      'TITULO': 'Umfrage abfragen',
      'HEADER': 'Wählen Sie das Institut',
      'INSTITUTOS': 'Institute',
      'FILTRO': 'Filter',
      'FILTRO_EMPRESA':'Firma filtern:',
      'FILTRO_TI_EMPR_TOKEN':'Token-Umfrage / Firmentyp filtern:',
      'SELECCIONFILTRO': 'Suche nach gewünschten Informationen',
      'BOTON_DESCARGA_EXCEL': 'Informationen im Excel-Format herunterladen',

      'CARGANDO': 'Informationen laden...',
      'NOMBRE_DE_EMPRESA': 'Name der Firma',
      'TIPO_DE_EMPRESA':'Typ der Firma',
      'FECHA_C': 'Datum der Gründung',
      'SECTOR': 'Branche',
      'SUBSECTOR': 'Teilsektor',
      'TIPO_ENC': 'Art der Erhebung',
      'PLANTILLA': 'Vorlage',
      'CATALOGOSPRODUCTOS': catalogos.plantillas,
      'TOKEN': 'Survey token',
      'ID_ENC': 'Umfrage-ID',
      'ANIO': 'Jahr',
      'CORREOS_EN': 'Mail gesendet',
      'FECHA_A': 'Datum der Anmeldung',
      'FECHA_CR': 'Abschlussdatum',

      'MODAL_SUCCES': 'Datei korrekt heruntergeladen',
      'MODAL_WARNING': 'Kein Institut ausgewählt',
      'VIZUENCU': 'Umfragen anzeigen',
      'SELE_AN_ENCU':'Seleccione un año',
    },
    'CONSULTAR_RT':{
      'TITULO':'Technische Anforderungen abfragen',
      'HEADER': 'Wählen Sie das Institut',
      'INSTITUTOS': 'Institute',
      'FILTRO': 'filtern',
      'SELECCIONFILTRO':'Suche nach dem gewünschten Unternehmen',
      'CARGANDO':'Informationen laden',
      'NOMBRE_DE_EMPRESA':'Name der Firma',
      'FECHA_DE_EMPRESA':'Erstellungsdatum',
      'PRODUCTO':'Produkttyp',
      'TOKEN':'Umfrage-Token',
      'ESTATUS':'Status',
      '0':'Nicht gestartet',
      '1':'In Bearbeitung',
      '2':'Beendet',
      'ACCIONES':'Aktionen',
      'PRODUCTOS':catalogos.productos,
      'ELEMENTOS':'Elemente pro Seite',
      'DE':'von',
      'SIGUIENTE':'Nächster',
      'ULTIMA':'Letzte Seite',
      'PRIMERA':'Erste Seite',
      'ANTERIOR':'Vorherige'

    },
    'PAQUETES':{
      'NOMBRES':{
        '1': 'SILBER-Paket',
        '2': 'GOLD-Paket',
        '3': 'PLATINUM-Paket',
      },
      'TOOLTIP':{
        'CONFIG': 'Zum Konfigurieren klicken',
      },
      'MENSAJES': {
        'ADDOK': 'Das Paket wurde erfolgreich zur Firma hinzugefügt. Jetzt können Sie die Produkte des gewählten Pakets konfigurieren',
        'NOTOK': 'Das Paket konnte nicht hinzugefügt werden, es ist bereits ein Paket dem angegebenen Jahr zugeordnet, versuchen Sie es erneut mit einer anderen Option',
        'USURE_PROD': 'Bestätigen Sie, dieses Produkt mit den gewählten Merkmalen zu konfigurieren?',
        'PROD_ACTIVADO': 'Dieses Produkt ist bereits aktiviert',
        'ONLYONE': 'In dieser Kategorie können Sie nur einen Produkttyp auswählen, wollen Sie den Vorgang mit dieser Auswahl fortsetzen?',
        'NOYEAR': 'Sie haben das Anwendungsjahr für das Paket nicht ausgewählt',
        'NOPAQ': 'Sie haben das zuzuordnende Paket nicht ausgewählt',
      },
      'PREVIO':{
        'INFO': 'Sie haben kein aktuelles Produktpaket aktiv',
        'BOTONES':{
          'ADD': 'Ein Paket hinzufügen',
          'SEE': 'Ein vorheriges Paket aufrufen',
          'CANCELAR': 'Abbrechen',
          'ADDPACK': 'Paket hinzufügen',
          'SI': 'Ja',
          'NO': 'Nein',
        },
        'STEPS': {
          '1': 'Wählen Sie das Paket aus, das Sie der Firma zuordnen möchten',
          '2': 'Wählen Sie das Anwendungsjahr für das Paket',
        }
      },
      'INFOPAQ':{
        'TITULO': 'Aktuelles Paket:',
        'APLICA': 'Anwendungsjahr:',
        'AVANCE': 'Aktueller Fortschritt der Paketkonfiguration',
        'STATUS':{
          'TITULO': 'Status:',
          'OK_1': 'Vollständige Konfiguration',
          'NOTOK_1': 'Unvollständige Konfiguration',
          'OK_2': 'Bereits aktiviert',
          'NOTOK_2': 'Nicht aktiviert',
          'ADICIONAL': 'Zusätzliche Produkte',
          'ADINFO': 'Hinweis: Ihr Hinzufügen ist optional',
        },
        'BOTONES':{
          'ADD': 'Produkt hinzufügen',
          'CANCELAR': 'Abbrechen',
          'SI': 'Ja',
          'NO': 'Nein',
          'BACK': 'Zurückgehen',
          'ADDONE': 'Ein Produkt hinzufügen',
          'DETAIL': 'Details ansehen',
        },
        'CERTIFICAR':{
          'TITULO':{
            '1': 'Sie haben dieses Produkt nicht aktiviert',
            '2': 'Sie haben dieses Produkt bereits aktiviert',
            '3': 'Dies ist eine Kategorie, Sie können die folgenden Produkte aktivieren:',
            '4': 'Dieses Produkt kann während der Lebensdauer des Pakets mehrfach zugewiesen werden',
          },
          'INSTRUC': 'Konfigurieren Sie dieses Produkt unten',
          'TIPO': 'Wählen Sie den Typ des Produkts',
          'INFO':{
            'TITULO': 'Produktinformation',
            'SECCIONES': 'Abschnitte',
            'TIPO': 'Typ',
            'TEMP': 'Ausgewählte Vorlage',
            'STATUS':{
              'TITULO': 'Aktueller Status',
              '1': 'Noch nicht fertig',
              '2': 'Beendet',
            },
            'TABLA':{
              '1': 'Produkt',
              '2': 'Optionen',
            }
          }
        }
      }
    },
    'AUDITORIA-AUTOMATICA':{
      'TITULO': 'Automatisierte Prüfung',
      'TABLA':{
        'TH-NOM-EMPRESA':'Firmenname',
        'TH-NO-COLAB':'Nr. Mitarbeiter',
        'TH-CONTESTADOS':'Beantwortet',
        'TH-FALTANTES':'Fehlt',
        'TH-PROGRESO':'Fortschritt',
        'TH-ACCIONES':'Aktionen',
        'MSJ-DETALLES':'Siehe Details',
      }

    },
    'RESULTA-AUDITO':{
      'TIEM-RES-TAB':'Zeitreaktionsmitarbeiter',
      'RES-CONT-TAB':'Kontrollantworten',
      'RES-COMENT-TAB':'Kommentarantworten',
      'TIEM-RES-TITULO':'Kontrolle der Antwortzeit der Kollaborateure',
      'RES-CONT-TITULO':'Prozentsatz der Antworten auf Kontrollfragen',
      'RES-COMENT-TITULO':'Prozentsatz der leeren, wiederholten oder wiederholten Zeichenkommentare',
      'RES-AGREGAR':'Hinzufügen einer Stichprobe',
      'RES-SELECCIONAR':'Stichprobe auswählen',
      'RES-TEXTO1':'Es wurde noch keine Probe angelegt',
      'RES-TEXTO2':'Bitte wählen Sie eine Probe aus, um die Daten anzuzeigen',
      'INGRE-NOM': 'Geben Sie den Namen der Probe ein',
      'SELEC-REG': 'Wählen Sie die Regeln der Probe',
      'REGLAS':{
        '1': 'Mitarbeiter, die in weniger als 10 Minuten geantwortet haben',
        '2': 'Mitarbeiter, die alle ihre Items mit einem Wert von 5 beantwortet haben',
        '3': 'Mitarbeiter, die die Kontrollfrage mit JA beantwortet haben',
        '4': 'Mitarbeiter, die eine zufällige Frage falsch beantwortet haben',
        '5': 'Mitarbeiter, die mehr als 10 Antworten geändert haben',
      },

      'TABLA':{
        'TITULO':'Daten der Mitarbeiter in der Stichprobe',
        'NOMBRE':'Name',
        'TELEFONO':'Telefon',
        'CELULAR':'Mobiltelefon',
        'CORREO':'E-Mail Adresse',
        'COMENTARIO':'Kommentar',
      },
      'MODALES':{
        'GENERANDO':'Generating sample, please wait...',
        'GUARDANDO':'Saving comment, please wait...',
        'TITULO':'Gespeicherter Kommentar',
        'CERRAR':'Schließen',
        'TITULO_INFORMACION':'Nach dem Hinzufügen des Kommentars kann das Feld nicht leer bleiben, es werden die zuletzt darin gespeicherten Daten übernommen',
        'SUCCE-MUES':'Das Muster wurde korrekt angelegt',
        'WARNI-SINU':'Es sind keine weiteren Benutzer mehr zu registrieren',
        'WARNI-CONDI':'Vergessen Sie nicht, einen Namen anzugeben und mindestens eine Regel auszuwählen',


      },
    },
    'DESCARGAR_ENCUESTA':{
      'NPS':'NPS',
      'REACTIVOS':'Anweisungen',
      'KONTROLLE':'Kontrolle',
      'DEMOGRAFICOS':'Demografien',
      'ABIERTAS':'Offen',
      'CA':'4ALL',
      'CODIGOPROYECTO':'Projektcode: ',
      'ANIOAPLICACION':'Jahr der Implementierung: ',
      'MENSAJE':'Es ist nicht möglich, die Umfrage herunterzuladen, da sie noch nicht erstellt wurde',
      'ACEPTAR':'Akzeptieren',
      'TEXTODESCARGA':'Umfrage von ',
      'DESCARGARENCUESTA':'Umfrage herunterladen',
      'INFORMACIONYAVISO':'Umfrageinformationen und Datenschutzhinweis',
      'SECCIONES':'Abschnitte',
      'TIPOENC1':'Weniger als 50',
      'TIPOENC2':'Mehr 50',
      'MODAL':{
        'TITLE':'Sprachenliste',
        'SUBTITLE':'Wählen Sie eine Sprache',
        'PLACEHOLDER':'Auswählen',
        'BTNCLOSE':'Schließen',
        'BTNSELECT':'Akzeptieren',
        'MAS50':'Mehr 50',
        'MENOS50':'Weniger 50',
        'TIPOENCUESTA':'Wählen Sie eine Umfrageart',
      }
    },
    'UPDATE_COLABORATORS':{
      'UPDATE':'Mitarbeiterdatenbank aktualisieren'
    },
    'INFORT': {
      'TITULO': 'Technische Anforderungen schreiten voran',
      'SINLANGS': 'Sie müssen die Sprachen in diesem Produkt auswählen, um die Liste der Schritte anzuzeigen',
      'PASOS': {
        'PASO_1': 'Schrittliste',
        'PASO_2': 'Fragebogen',
        'PASO_3': 'Aufzeichnung'
      },
      'LISTAPASOS': {
        'autentication': 'Umfrageauthentifizierung',
        'testAccess': 'Test anzeigen',
        'testEmail': 'Nachweis des E-Mail-Empfangs',
        'validationQ': 'Validierungsfragebogen',
        'requirements': 'Datenschutzerklärung',
      },
      'STATUS': {
        'PEND': 'steht aus',
        'DONE': 'Schritt abgeschlossen',
      },
      'RESP': 'Antwort gesendet',
      'NORESP': 'Unbeantwortet'
    },
    'MODAL_CONSULT_INFRAESTRU':{
      'TITL':'Dedizierte Infrastruktur:',
      'INSTRUC_1':'Möchten Sie eine dedizierte Infrastruktur hinzufügen?',
      'LAB_SUBDOMINIO':'Unterdomäne',
      'WARN_CARACT':'Das Feld lässt den Buchstaben ñ, Großbuchstaben und Sonderzeichen nicht zu',
      'BTN_CONTI':'Weiter',
      'SI':'Ja',
      'NO':'Nein',
      'MODA_IMPORT_SUBDOM':'Um fortzufahren, müssen Sie die Subdomain eingeben',
    }
  }
};
